import { memo } from 'react';
import Animated, {
  useAnimatedKeyboard,
  useAnimatedStyle,
} from 'react-native-reanimated';

export const KeyboardSpacerView = memo(() => {
  const { height } = useAnimatedKeyboard();
  const style = useAnimatedStyle(() => ({
    height: height.value,
  }));
  return <Animated.View style={style} />;
});
